import { render, staticRenderFns } from "./PaymentGateways.vue?vue&type=template&id=d9c3cf40&scoped=true"
import script from "./PaymentGateways.vue?vue&type=script&lang=js"
export * from "./PaymentGateways.vue?vue&type=script&lang=js"
import style0 from "./PaymentGateways.vue?vue&type=style&index=0&id=d9c3cf40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c3cf40",
  null
  
)

export default component.exports